import { render, staticRenderFns } from "./EventPanel.vue?vue&type=template&id=4b376e78&scoped=true"
import script from "./EventPanel.vue?vue&type=script&lang=js"
export * from "./EventPanel.vue?vue&type=script&lang=js"
import style0 from "./EventPanel.vue?vue&type=style&index=0&id=4b376e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b376e78",
  null
  
)

export default component.exports